export interface LoginRequest {
    email: string;
    password: string;
    recaptchaToken: string;
}

export enum TrialSignupErrorCode {
    TRIAL_SIGNUPS_DISABLED = 'TRIAL_SIGNUPS_DISABLED',
    PLAYER_ALREADY_EXISTS = 'PLAYER_ALREADY_EXISTS',
}

export interface LoginResponse {
    status: 'success' | 'challenge' | 'error';
    message?: string;
    challengeName?: string;
    session?: string;
    challengeParameters?: { [key: string]: string };
    playerId?: string;
}

export interface SetPasswordRequest {
    username: string;
    newPassword: string;
    session: string;
}

export interface SetPasswordResponse {
    status: 'success' | 'error';
    message?: string;
}

export interface ForgotPasswordRequest {
    email: string;
    recaptchaToken: string;
}

export interface ForgotPasswordResponse {
    status: 'success' | 'error';
    message?: string;
}

export interface ResetPasswordRequest {
    email: string;
    confirmationCode: string;
    newPassword: string;
}

export interface ResetPasswordResponse {
    status: 'success' | 'error';
    message?: string;
}

export interface SignupRequest {
    email: string;
    userName: string;
    password: string;
    confirmPassword: string;
    gameInviteId: string;
}

export interface SignupResponse {
    status: 'success' | 'error';
    message?: string;
    playerId?: string;
}

export interface StripeSessionResponse {
    status: 'success' | 'error';
    message?: string;
    clientSecret?: string;
}

export enum StripeSubscriptionStatus {
    NONE = 'none',
    UNKNOWN = 'unknown',
    INCOMPLETE = 'incomplete',
    INCOMPLETE_EXPIRED = 'incomplete_expired',
    ACTIVE = 'active',
    TRIALING = 'trialing',
    PAST_DUE = 'past_due',
    CANCELED = 'canceled',
    UNPAID = 'unpaid',
}

export enum MindfulTrialStatus {
    NONE = 'none',
    ACTIVE = 'active',
    EXPIRED = 'expired',
}

export enum PlayerTrialSignupStatus {
    NONE = 'NONE',
    INITIAL = 'INITIAL',
    PLAYER_CREATED = 'PLAYER_CREATED',
    TRIAL_CREATED = 'TRIAL_CREATED',
}

export interface AccountInfo {
    username: string;
    email: string;
    stripeSubscriptionStatus: StripeSubscriptionStatus;
    mindfulTrialStatus: MindfulTrialStatus;
    subscriptionEndDate?: string;
    autorenew: boolean;
    trialSignupStatus?: PlayerTrialSignupStatus;
}

export interface AccountInfoResponse {
    status: 'success' | 'error';
    message?: string;
    stripeSubscriptionStatus?: StripeSubscriptionStatus;
    mindfulTrialStatus?: MindfulTrialStatus;
    account?: AccountInfo;
}

export interface UpdateUsernameRequest {
    name: string;
}

export interface UpdateUsernameResponse {
    status: 'success' | 'error';
    message?: string;
}

export interface ChangePasswordRequest {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export interface ChangePasswordResponse {
    status: 'success' | 'error';
    message?: string;
}

export interface CancelSubscriptionResponse {
    status: 'success' | 'error';
    message?: string;
}

export interface CancelSubscriptionRequest {
    reason?: string;
}

export interface ReactivateSubscriptionResponse {
    status: 'success' | 'error';
    message?: string;
    hostedInvoiceUrl?: string;
}

export interface PaymentPortalResponse {
    status: 'success' | 'error';
    message?: string;
    portalSessionURL?: string;
}

export interface AttemptSubscriptionCreationRequest {
    email: string;
    userName: string;
    password: string;
    confirmPassword: string;
    paymentMethodId: string;
    recaptchaToken: string;
}

export interface AttemptSubscriptionCreationExistingUserRequest {
    paymentMethodId: string;
}

export interface AttemptSubscriptionCreationResponse {
    status: 'success' | 'error';
    message?: string;
    playerId?: string;
    subscriptionId?: string;
    hostedInvoiceUrl?: string;
}

export interface CompleteSignupRequest {
    token: string;
    userName: string;
    password: string;
    confirmPassword: string;
    recaptchaToken: string;
}

export interface CompleteSignupResponse {
    status: 'success' | 'error';
    message?: string;
    playerId?: string;
}

export interface AcceptInviteRequest {
    inviteCode: string;
}

export interface AcceptInviteResponse {
    status: 'success' | 'error';
    message?: string;
    playerId?: string;
    gameId?: string;
}

export interface StartTrialEmailSignupRequest {
    email: string;
    recaptchaToken: string;
}

export interface StartTrialEmailSignupResponse {
    status: 'success' | 'error';
    message?: string;
    code?: TrialSignupErrorCode | string;
}

export interface TrialEmailSignupSetPasswordRequest {
    code: string;
    username: string;
    password: string;
    confirmationPassword: string;
}

export interface TrialEmailSignupSetPasswordResponse {
    status: 'success' | 'error';
    message?: string;
}
